import React from "react";
import { P } from "common/P/P";

const MultiSelectItem = ({ value, onSelect, children, isSelected }: any) => {
	return (
		<div
			onClick={() => onSelect(value)}
			className="flex items-center px-4 py-3 cursor-pointer hover:bg-lowOpacity"
		>
			<input type="checkbox" checked={isSelected} readOnly className="mr-2" />
			<P size="t1" type="regular" className="cursor-pointer">
				{children}
			</P>
		</div>
	);
};

export default MultiSelectItem;
